<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <h2 class="mb-4">Team Members</h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="members"
            :search="search"
            :loading="loading"
          >
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  name: 'TeamMembers',
  data() {
    return {
      search: '',
      loading: true,
      headers: [
        { text: 'Employee Name', value: 'employeeName' },
        { text: 'Designation', value: 'designation' },
        { text: 'Reporting Manager', value: 'reportingManagerName' }
      ],
      members: []
    };
  },
  async created() {
    await this.fetchMembers();
  },
  methods: {
    async fetchMembers() {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.get('/my-team/members', {
          headers: { 'x-auth-token': token }
        });
        if (res.data && res.data.status) {
          this.members = res.data.data;
        }
      } catch (e) {
        console.error("Error fetching members:", e);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
